// Resolves the initial currentSelectedRowIndex for the Detail page so the
// first render lands on the correct row. Without this Detail would render
// rows[0] briefly, which resets SlaveDatasetContext (losing the subset
// expandedRow + scroll target) before the debounced effect corrects it.
//
// Priority: expandedRow match -> URL itemId match -> 0.
export const getInitialDetailRowIndex = (
  rows: any[] | undefined,
  dataKey: string | undefined,
  expandedRow: any,
  itemId: string | undefined
): number => {
  if (!rows?.length || !dataKey) return 0;

  if (expandedRow) {
    const idx = rows.findIndex((row) => row[dataKey] === expandedRow[dataKey]);
    if (idx >= 0) return idx;
  }

  if (itemId) {
    const idx = rows.findIndex(
      (row) => String(row[dataKey]) === String(itemId)
    );
    if (idx >= 0) return idx;
  }

  return 0;
};
